import React from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from '@mui/material';
import CodebarIn from './CodebarIn'; // Verifique o caminho conforme necessário

const RopeForm = ({
  formData,
  handleChange,
  isCertified,
  handleCertifiedChange,
  noPalletsWarning,
  showCodebarInput,
  remaining,
  barcodeInput,
  onBarcodeSubmit,
  barcodeError,
  localBarcodesFinalized,
  barcodes
}) => {
  const unidadeOptions = [
    { label: 'KG', value: 'KG' },
    { label: 'Km', value: 'Km' },
    { label: 'Metr', value: 'Metr' }
  ];

  const certificateOptions = [
    { label: 'FSC MIX 70%', value: 'FSC MIX 70%' },
    { label: 'PEFC 100%', value: 'PEFC 100%' }
  ];

  return (
    <Grid container spacing={2}>
      {/* Material */}
      <Grid item xs={12}>
        <TextField
          label="Material"
          name="material"
          fullWidth
          value={formData.material || ''}
          onChange={handleChange}
        />
      </Grid>

      {/* Quantidade total (Length) */}
      <Grid item xs={12}>
        <TextField
          label="Quantidade total"
          name="length"
          fullWidth
          value={formData.length || ''}
          onChange={handleChange}
        />
      </Grid>

      {/* Color */}
      <Grid item xs={12}>
        <TextField
          label="Color"
          name="color"
          fullWidth
          value={formData.color || ''}
          onChange={handleChange}
        />
      </Grid>

      {/* Quantidade/Bobine */}
      <Grid item xs={12}>
        <TextField
          label="Quantidade/Bobine"
          name="quantidade_bobine"
          fullWidth
          value={formData.quantidade_bobine || ''}
          onChange={handleChange}
        />
      </Grid>

      {/* Dropdown para Unidade */}
      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel>Unidade (KG/Km/Metr)</InputLabel>
          <Select
            name="unidade"
            value={formData.unidade || ''}
            onChange={handleChange}
            label="Unidade (KG/Km/Metr)"
          >
            {unidadeOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {/* Checkbox para material certificado */}
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isCertified}
              onChange={(e) => handleCertifiedChange(e.target.checked)}
              name="is_certified"
            />
          }
          label="Material Certificado?"
        />
      </Grid>

      {/* Se for certificado, exibe a dropdown de certificação */}
      {isCertified && (
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Certificação</InputLabel>
            <Select
              name="certificate"
              value={formData.certificate || ''}
              onChange={handleChange}
              label="Certificação"
            >
              {certificateOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}

      {/* Opção para utilizar os códigos de barras do fornecedor */}
      <Grid item xs={12}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography style={{ marginRight: '1rem' }}>
            Usar código de barras do fornecedor?
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.supplier_barcode === 'sim'}
                onChange={() =>
                  handleChange({ target: { name: 'supplier_barcode', value: 'sim' } })
                }
                name="supplier_barcode"
              />
            }
            label="Sim"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.supplier_barcode === 'nao'}
                onChange={() =>
                  handleChange({ target: { name: 'supplier_barcode', value: 'nao' } })
                }
                name="supplier_barcode"
              />
            }
            label="Não"
          />
        </div>
      </Grid>

      {/* Aviso para número de paletes */}
      {noPalletsWarning && (
        <Grid item xs={12}>
          <Typography color="error">
            Por favor, insira o número de paletes.
          </Typography>
        </Grid>
      )}

      {formData.supplier_barcode === 'sim' && (
        <Grid item xs={12}>
          <CodebarIn
            remaining={remaining}
            barcodeInput={barcodeInput}
            onBarcodeInputChange={(e) =>
              handleChange({ target: { name: 'barcodeInput', value: e.target.value } })
            }
            onBarcodeSubmit={onBarcodeSubmit}
            barcodeError={barcodeError}
          />
        </Grid>
      )}

      {/* Exibe os códigos de barras finalizados */}
      {localBarcodesFinalized && barcodes && barcodes.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h6">Códigos de Barras Finalizados:</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Código de Barras</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {barcodes.map((code, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{code}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      )}
    </Grid>
  );
};

export default RopeForm;
